import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconIconShape16(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={16}
            height={16}
            className={customClassName}
            name="IconIconShape16"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M4 3h8q.135 0 .259.034L10.453 4.84A4 4 0 0 0 8 4c-.924 0-1.775.314-2.453.84L3.741 3.034Q3.866 3 4 3m-.966.741Q3 3.866 3 4v8q0 .135.034.259l1.806-1.806A4 4 0 0 1 4 8c0-.924.314-1.775.84-2.453zm2.52 2.52a3 3 0 0 0 .001 3.477L7.293 8zM8 8.708l-1.738 1.738c.49.35 1.09.555 1.738.555s1.248-.205 1.738-.555zm2.445 1.031L8.707 8l1.738-1.738c.35.49.555 1.09.555 1.738s-.205 1.248-.555 1.738m.008 1.422A3.98 3.98 0 0 1 8 12a3.98 3.98 0 0 1-2.453-.84l-1.806 1.806Q3.866 13 4 13h8a1 1 0 0 0 .259-.034zm2.513 1.1-1.806-1.807C11.687 9.775 12 8.924 12 8s-.313-1.775-.84-2.453l1.806-1.806Q13 3.866 13 4v8q0 .134-.034.26M8 7.292 6.262 5.555C6.752 5.205 7.352 5 8 5s1.248.205 1.738.555zM2 4a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2z"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconIconShape16);
